import { useEffect } from 'react';
import type { EndpointLockKeys } from '@/api';
import { acquireEndpointLock, releaseEndpointLock, useAppDispatch } from '@/store';

/**
 * Holds `lockId` on while `isActive` is true and the calling component is mounted, so the base query refuses the
 * lock's endpoints. Any number of components can hold the same lock; it comes off when the last one lets go.
 */
export const useEndpointLock = (lockId: EndpointLockKeys, isActive: boolean) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isActive) return;

    dispatch(acquireEndpointLock(lockId));

    return () => {
      dispatch(releaseEndpointLock(lockId));
    };
  }, [dispatch, lockId, isActive]);
};
